interface AuthLogEvent {
  event: 'refresh_start' | 'refresh_success' | 'refresh_failed' | 'preemptive_refresh' | 'login_success' | 'login_failed' | 'logout' | 'session_check_failed' | 'session_retry_failed' | 'auth_check_error' | 'existing_session_invalid';
  timestamp: number;
  details?: any;
  error?: Error;
}

class AuthLogger {
  private events: AuthLogEvent[] = [];
  private maxEvents = 100; // Keep last 100 events

  log(event: AuthLogEvent['event'], details?: any, error?: Error): void {
    const logEvent: AuthLogEvent = {
      event,
      timestamp: Date.now(),
      details,
      error
    };

    this.events.push(logEvent);
    
    // Keep only recent events
    if (this.events.length > this.maxEvents) {
      this.events = this.events.slice(-this.maxEvents);
    }

    // Console output ONLY in development mode to prevent Sentry from capturing these
    if (import.meta.env.DEV) {
      const prefix = `[AUTH:${event.toUpperCase()}]`;
      if (error) {
        console.error(prefix, details || '', error);
      } else if (event.includes('failed')) {
        console.error(prefix, details || '');
      } else if (event.includes('start') || event.includes('success')) {
        console.info(prefix, details || '');
      } else {
        console.log(prefix, details || '');
      }
    }
    
    // In production, silently collect events but don't log to console
    // This prevents Sentry's captureConsoleIntegration from capturing AUTH errors
  }

  getEvents(): AuthLogEvent[] {
    return [...this.events];
  }

  exportLogs(): string {
    return JSON.stringify(this.events, null, 2);
  }

  clearLogs(): void {
    this.events = [];
    if (import.meta.env.DEV) {
      console.info('[AUTH:CLEAR_LOGS] Authentication logs cleared');
    }
  }
}

export const authLogger = new AuthLogger();